import React from "react";

const NoMatch = () => {
  return <>4040404040404040</>;
};

export default NoMatch;
